
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import InputSwitch from 'primevue/inputswitch'
import DatasetScheduler from '@/modules/managers/datasetManagement/detailView/advancedCard/DatasetManagementScheduler.vue'
import Card from 'primevue/card'
import descriptor from './QBESavingDialogDescriptor.json'

export default defineComponent({
    name: 'olap-custom-view-save-dialog',
    components: { Card, KnValidationMessages, InputSwitch, DatasetScheduler },
    props: { propDataset: Object, schedulingData: Object },
    computed: {
        disablePersist() {
            if (this.dataset['pars'] && this.dataset['pars'].length > 0) {
                return true
            }
            return false
        }
    },
    data() {
        return {
            v$: useValidate() as any,
            dataset: {} as any,
            descriptor
        }
    },
    created() {
        this.dataset = this.propDataset
    },
    watch: {
        selectedDataset() {
            this.dataset = this.propDataset
        }
    },
    validations() {
        const persistFieldsRequired = (value) => {
            return !this.dataset.isPersisted || value
        }
        const customValidators: ICustomValidatorMap = {
            'persist-field-required': persistFieldsRequired
        }
        const validationObject = {
            dataset: createValidations('dataset', descriptor.validations.advancedTab, customValidators)
        }
        return validationObject
    },
    methods: {
        updateIdFromCd(optionsArray, fieldToUpdate, updatedField) {
            const selectedField = optionsArray.find((option) => option.VALUE_CD === updatedField)
            selectedField ? (this.dataset[fieldToUpdate] = selectedField.VALUE_ID) : ''
        }
    }
})
